const ActivityCircleIcon = /*#__PURE__*/ [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 17L8.58579 12.4142C9.25245 11.7475 9.58579 11.4142 10 11.4142C10.4142 11.4142 10.7475 11.7475 11.4142 12.4142L11.5858 12.5858C12.2525 13.2525 12.5858 13.5858 13 13.5858C13.4142 13.5858 13.7475 13.2525 14.4142 12.5858L20 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { ActivityCircleIcon as default };
//# sourceMappingURL=ActivityCircleIcon.js.map
